import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SupplierService, UserService } from '../../../../services';
import { IUser } from '../../../../interfaces/user';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Message } from '../../../../classes/Message';
import { FileUpload, MessageService } from 'primeng';
import { deepClone } from 'fast-json-patch';

@Component({
  selector: 'gamification-profile',
  templateUrl: 'gamification-profile.component.html',
  styleUrls: ['gamification-profile.component.scss'],
})
export class GamificationProfileComponent implements OnInit {
  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    public messageService: MessageService,
    private supplierService: SupplierService,
  ) {}

  @ViewChild('pUploader') pUploader: FileUpload;

  public user: IUser;
  public userOrg: any;
  editProfileVisible = false;
  userForm: FormGroup;

  preEdit: any;
  userOrgForm: FormGroup;
  public uploadedFileSrc: string;

  ngOnInit() {
    this.loadProfile();
  }

  loadProfile() {
    this.userService.getLoggedUser().then((res) => {
      this.user = res;
      this.createUserForm();
    });

    this.userService.getCurrentUserOrg().then((res) => {
      this.userOrg = res;
      this.createUserOrgForm();
    });
  }

  createUserForm() {
    this.userForm = this.formBuilder.group({
      id: [this.user.id],
      imageUrl: [this.user.profileImageUrl],
      firstname: [this.user.firstName, Validators.compose([Validators.required])],
      lastname: [this.user.lastName, Validators.compose([Validators.required])],
      phoneNumber: [this.user.phoneNumber, Validators.compose([Validators.required])],
      email: [this.user.email, Validators.compose([Validators.required, Validators.email])],
    });
  }

  createUserOrgForm() {
    // if current user is not an individual, don't allow organisation address edit
    if (this.userOrg.organisationSubTypeId != 1) {
      return;
    }

    this.userOrgForm = this.formBuilder.group({
      id: [this.userOrg.id],
      addressLine1: [this.userOrg.addressLine1],
      addressLine2: [this.userOrg.addressLine2],
      addressLine3: [this.userOrg.addressLine3],
      postcode: [this.userOrg.postcode],
    });

    this.preEdit = Object.assign({}, this.userOrgForm.value);
  }

  editProfile() {
    this.editProfileVisible = true;
  }

  dialogVisibleChanged($event: any) {
    this.editProfileVisible = false;
  }

  onBeforeProfileImageUpload(event) {
    event.formData.append('userId', this.user.id);
    event.xhr.responseType = 'json';
  }

  onSelectProfileImage(event) {
    this.getImageSource(this.pUploader.files[0]).then((src) => {
      this.uploadedFileSrc = src;
    });
  }

  onProfileImageUploadError(event) {
    this.messageService.add(Message.Error('<div>Profile image could not be uploaded.</div>'));
  }

  onProfileImageUpload(event) {
    this.save(this.userForm.value);
  }

  profileImageChanged(): boolean {
    return (
      this.pUploader &&
      this.pUploader.files.length > 0 &&
      this.pUploader.files[0].name != 'existing'
    );
  }

  save(formValues) {
    const user = <IUser>formValues;

    // The call to upload() does not return a promise so instead
    // onUpload callback calls save()
    if (this.profileImageChanged()) {
      this.pUploader.upload();
    }

    this.userService.save(user).then((data) => {
      this.loadProfile();
      this.editProfileVisible = false;
    });

    // save organisation address
    let preData = Object.assign({}, this.preEdit);
    let newData = Object.assign({}, this.userOrgForm.value);

    this.supplierService.patch(this.userOrg.id, newData, preData).then((result) => {
      this.preEdit = Object.assign({}, this.userOrgForm.value);
      this.userOrg = result;
    });
  }

  private getImageSource(file: File): Promise<string> {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onload = (e) => res(reader.result as string);
      reader.onerror = (e) => rej(e);
      reader.readAsDataURL(file);
    });
  }

  UploadFile() {
    this.pUploader.advancedFileInput.nativeElement.click();
  }

  onSubmit() {
    this.save(this.userForm.value);
  }
}
